/**
 * @returns today date string in format aaaa-mm-dd
 */
export function getTodayStringUtc() {
    const nowDateUtc = new Date(new Date().toISOString());
    return getDateString(nowDateUtc);
}

/**
 * @returns {String} date in aaaa-mm-dd format
 */
export function getDateString(dateObject) {
    const year = dateObject.getFullYear();
    const month = dateObject.getMonth() + 1;
    const day = dateObject.getDate();
    const todayString = year + '-' +
        (
            month <= 9 ?
                ('0' + month.toString()) :
                month.toString()
        ) + '-' +
        (
            day <= 9 ?
                ('0' + day.toString()) :
                day.toString()
        );
    return todayString;
}

/**
 * @returns {String} Time in hh:mm:ss format
 */
export function getTimeString(dateObject) {

    const hours = dateObject.getHours();
    const minutes = dateObject.getMinutes();
    const seconds = dateObject.getSeconds();

    const timeString =
        (
            hours <= 9 ?
                ('0' + hours) :
                hours
        ) + ':' +
        (
            minutes <= 9 ?
                ('0' + minutes) :
                minutes
        ) + ':' +
        (
            seconds <= 9 ?
                ('0' + seconds) :
                seconds
        );

    return timeString;
}

/**
 * @returns {String} date in aaaa-mm-dd format
 */


function getLang() {
    if (navigator.languages !== undefined)
        return navigator.languages[0];
    else
        return navigator.language;
}


/**
 * 
 * @param {String} dateKey date in aaaa-mm-dd format
 * @returns {String} date in aaaa-mm-dd format
 */
export function getDateText(dateKey) {
    const day = new Date(dateKey);

    const local = getLang();

    const option = { month: '2-digit', day: '2-digit', weekday: 'short' };

    const dateTextFormated = day.toLocaleDateString(local, option);

    return dateTextFormated;
}